import api from '@/lib/axios';

export interface GoogleDocsConfig {
  viewerEmails?: string[];
  approverUserIds?: string[];
}

export interface UserForApprovers {
  id: string;
  email: string;
  name: string;
}

export const googleDocsIntegrationService = {
  getConfig(): Promise<GoogleDocsConfig & { id?: string; tenantId?: string; createdAt?: string; updatedAt?: string }> {
    return api.get('/google-docs-integration/config').then((r) => r.data);
  },

  updateConfig(data: { viewerEmails?: string[]; approverUserIds?: string[] }): Promise<GoogleDocsConfig> {
    return api.put('/google-docs-integration/config', data).then((r) => r.data);
  },

  listUsers(): Promise<UserForApprovers[]> {
    return api.get<UserForApprovers[]>('/google-docs-integration/users').then((r) => r.data);
  },
};
